<!-- Shared template for critical post content -->
<ng-template #criticalPostTemplate let-post="post">
  <div class="critical-card" style="text-align: left">
    <div class="critical-badge">
      Critical
    </div>
    <div class="critical-header">
      <i class="icon-warning icon-red" style="width: 32px; height: 32px;"></i>
      <div class="header-text">
        <h1>{{ post.Title }}</h1>
      </div>
    </div>
    <p class="critical-post-date">
      <small class="text-muted">{{ post.PostedDateUTC | nhaDate:'relativeDayAndTime' }}</small>
    </p>
    <div class="critical-post-content" [innerHTML]="post?.SanitizedDescription" appInAppLinks></div>
    <div class="critical-post-actions">
      <button type="button" data-testid="critical-alert-acknowledge-btn" class="btn btn-danger" (click)="onDismissCriticalAlertClick(post.Id)">
        Acknowledge
      </button>
      <button type="button" data-testid="critical-alert-acknowledge-view-btn" class="btn btn-danger-secondary" (click)="navigateToPost(post.Id)">
        Acknowledge & View Post
      </button>
    </div>
  </div>
</ng-template>

  @for (post of posts; track post) {
    @if (post && !post.IsDismissed) {
      <div class="modal-overlay">
        <ng-container *ngTemplateOutlet="criticalPostTemplate; context: { post: post }"></ng-container>
      </div>
    }
  }
